import axios from "axios";
import React, { useState } from "react";
import ImageLoading from "../../components/ImageLoading";
import NoDataFound from "../../components/NoDataFound";
import { FiDownload } from "react-icons/fi";
import BsaDateSelect from "../../components/BsaDateSelect";

function ConsentSummaryHistory({ id }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [noData, setNoData] = useState(false);
  const [showModal, setShowModal] = useState(false);

  function formatString(str) {
    if (str === null) return "---";
    if (str === "cams_aa_finserv") return "Cams AA Finserv";
    return str
      .replace(/_/g, " ") // Replace underscores with spaces
      .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize the first letter of each word
  }
  const fetchConsentSummary = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/v1/users/${id}/user_consented_aggregators_summary`,
        method: "GET",
        headers: { Authorization: token },
      };
      const res = await axios(options);
      if (res.data.user_consent_summary_history.length > 0) {
        setData(res.data.user_consent_summary_history);
        setLoading(false);
      } else {
        setNoData(true);
        setLoading(false);
      }
    } catch (error) {}
  };

  useState(() => {
    fetchConsentSummary();
  }, []);
  return (
    <>
      {loading && (
        <div className="w-full h-[calc(100vh-190px)] flex items-center justify-center bg-white mt-4 rounded-lg">
          <ImageLoading />
        </div>
      )}
      {noData && (
        <div className="w-full h-[calc(100vh-190px)] flex items-center justify-center bg-white mt-4 rounded-lg">
          <NoDataFound />
        </div>
      )}
      {!loading && !noData && (
        <div className=" mt-4 w-full overflow-auto max-h-[calc(100vh-190px)] bg-white rounded-lg py-4">
          <div className=" text-base font-bold mx-4 mb-4 flex justify-between items-center">
            <p> Consent Summary History</p>
            <button
              onClick={() => setShowModal(true)}
              className="text-sm font-semibold w-[124px] h-[30px] flex items-center justify-center bg-[#00394d] text-white rounded"
            >
              <span className=" mr-2">
                <FiDownload />
              </span>
              Download
            </button>
          </div>
          <div className="flex justify-between text-sm font-semibold px-4 min-h-[36px]">
            <p className="w-[15%]">Provider</p>

            <p className="w-[15%] text-right ">Total Successful Fetch</p>
            <p className="w-[20%] text-right ">Total Failed Fetch</p>
            <p className="w-[20%] text-right ">Total Pending</p>
            <p className="w-[20%] text-right ">No of Hits</p>
            <p className="w-[22%] text-right">Last successful Fetch</p>
          </div>
          {data.map((data, index) => {
            return (
              <>
                <div
                  key={index}
                  className={`flex justify-between text-xs font-medium h-[36px] items-center  px-4 ${
                    index % 2 === 0 ? "bg-[#f8f8f8]" : ""
                  }`}
                >
                  <p className="w-[15%]">
                    {/* {key==="mutual_funds" || key==="stocks"?} */}
                    {formatString(data.provider) || "---"}
                  </p>

                  <p className="w-[15%] text-right ">
                    {data.total_successful_fetch !== null
                      ? data.total_successful_fetch
                      : "---"}
                  </p>
                  <p className="w-[20%] text-right ">
                    {data.total_failed_fetch !== null
                      ? data.total_failed_fetch
                      : "---"}
                  </p>
                  <p className="w-[20%] text-right ">
                    {" "}
                    {data.total_pending_fetch !== null
                      ? data.total_pending_fetch
                      : "---"}{" "}
                  </p>
                  <p className="w-[20%] text-right ">
                    {data.no_of_hits !== null ? data.no_of_hits : "---"}
                  </p>
                  <p className="w-[22%] text-right ">
                    {data.last_successful_fetch || "---"}
                  </p>
                </div>
              </>
            );
          })}
        </div>
      )}
      {showModal && (
        <BsaDateSelect
          setShowModal={setShowModal}
          downLoadType={"individual"}
          id={id}
        />
      )}
    </>
  );
}

export default ConsentSummaryHistory;
